import { FC } from "react";
import { Link } from "react-router-dom";
import { RouteDetailsList } from "./RouteDetailsList";

interface RouteDetailProps {
  subtitle: string;
  routeDescription: string;
  downloadMapLink: string;
  path: string;
  src: string;
  index: number;
}

export const RouteDetail: FC<RouteDetailProps> = ({
  subtitle,
  routeDescription,
  downloadMapLink,
  path,
  src,
}) => {
  return (
    <div className="flex flex-col justify-between md:flex-row items-center mx-6 mb-6 md:gap-14">
      <div className="w-full mb-2 md:mb-0">
        <h3 className="text-2xl xl:text-3xl font-bold mb-2">{subtitle}</h3>
        <RouteDetailsList>
          <li>{routeDescription}</li>
          <li>
            <Link
              to={path}
              target="_blank"
              className="underline hover:text-primary-dark"
            >
              {downloadMapLink}
            </Link>
          </li>
        </RouteDetailsList>
      </div>
      <Link to={path} target="_blank" className="w-full lg:w-2/3">
        <img
          src={src}
          alt="Mapy.cz"
          className="w-full aspect-[4/3] object-contain rounded-lg shadow-lg"
        />
      </Link>
    </div>
  );
};
